
import React, {useEffect, useState} from "react";
import SinglePageLayout from "../../layouts/singlePageLayout/singlePageLayout";

import { showLoading, hideLoading } from 'react-redux-loading-bar';
import {useNavigate } from "react-router-dom";
import {connect} from 'react-redux';
import './funnel.scss';
import logo from './../../assets/images/cklogo.png';


const Funnel = ({ displayLoading, hideLoading }) => {
    const navigate = useNavigate();

    const sendToPaymentMethodPage = () => {
        navigate('/sign-in?redir=subscription/payment-method/32');
    }


    return (
        <SinglePageLayout>
            <div className="funnel-container">
                <div className="ck-container">
                    <div className="ck-bordered-box">
                        <div className="top-logo">
                                                <img src={logo} alt="Clubkillers sign in" title="Clubkiller sing in" style={{maxWidth: '100px' }} />
                                            </div>
                            <div className="ck-divider"></div>

                        <div className="ck-section  ck-banner">
                            <a href="https://djtools.clubkillers.com/subscription/plans/2026" target="_blank" rel="noopener">
                                <img src="https://files.constantcontact.com/97ba36fa801/f9e81c97-fec4-45df-b2bd-7318f7c3af6d.png?rdr=true" alt="Renew your Club Killers subscription" />
                            </a>
                        </div>

                        <div className="ck-section  ck-hero-text text-center">
                            <h1 class="text-4xl font-bold text-green-400 mb-2">WELCOME BACK!</h1>
                            <div className="ck-divider"></div>
                            <div className="ck-divider"></div>
                            <div class="text-5xl font-bold mb-2">BEST DEAL OF THE YEAR</div>
                            <div className="ck-divider"></div>
                            <div className="ck-divider"></div>
                            <div class="text-4xl font-bold mb-2">RENEW FOR JUST $14.99/MONTH</div>
                            <div className="ck-divider"></div>
                            <div class="text-4xl font-bold mb-2">Normally $30/month</div>
                            <div className="ck-divider"></div>
                        </div>

                        <div className="ck-section  ck-divider-wrap">
                            <div className="ck-divider"></div>
                
                        </div>

                        <div className="ck-section  ck-offer-text text-center">
                            <h2 className="ck-promo"><span className="text-4xl font-bold  mb-2">USE CODE: </span><span className="text-4xl text-green-400">CKDJ15</span></h2>
                        </div>

                        <div className="ck-section  ck-cta ">
                            <a className="ck-btn" href="https://djtools.clubkillers.com/subscription/stripe-payment-method/1" target="_blank" rel="noopener">RENEW NOW</a>
                        </div>

                        <div className="ck-section  ck-divider-wrap">
                            <div className="ck-divider"></div>
                        </div>

                        <div className="ck-section  ck-limited-text">
                            <p className="ck-limited-heading">LIMITED TIME ONLY!</p>
                            <p className="text-center">Take advantage of the BEST deal of the year!
                            This exclusive offer is available for a limited time only.
                            Don't miss your chance - sign up today before this offer is gone</p>
                        </div>

                        

                    </div>
                </div>

                
            </div>
        </SinglePageLayout>
    );
}
function mapStateToProps(state) {
  return {
	
  };
}

function mapDispatchToProps(dispatch) {
  	return {
      	displayLoading: (sectionBar) => dispatch(showLoading(sectionBar)),
        hideLoading: (sectionBar) => dispatch(hideLoading(sectionBar)),
        
  	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Funnel);